/* eslint-disable no-unused-vars */
import "react-phone-input-2/lib/style.css";
import { Route, Routes } from "react-router-dom";
import PublicRoutes from "./config/navigation.config/publicRoutes";
import ProtectedRoutes from "./config/navigation.config/protectedRoutes";
import { protectedRoutes, publicRoutes } from "./config/routes.config";
import NotFound from "./views/404";
import AuthController, { useAuth } from "./controllers/auth";
import { useEffect, useState } from "react";
import { useTheme } from "next-themes";
import NotificationController from "./controllers/NotificationController";
import { setAwsUrlEnum } from "./store/slices/EnumsSlice";
import store from "./store";
// import { ToastContainer } from "react-toastify";

function App() {
  const { authenticated, user, session } = useAuth();

  console.log(authenticated, user, session, "@user");
  const { theme, setTheme } = useTheme();

  !user && AuthController.restorePersistedCredentials();

  useEffect(() => {
    if (!!user && !session?.fcm_token) {
      NotificationController.getFcmToken()
        .then((res) => {
          NotificationController.saveFcmToken(res);
          console.log("@token fcm....", res);
        })
        .catch((err) => {
          console.log("@token fcm err....", err);
        });
    }
  }, [user, !session?.fcm_token]);

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) {
      setTheme(savedTheme);
    } else {
      setTheme(theme === "system" ? "light" : theme);
    }
    // setMounted(true);
  }, [setTheme, theme]);

  NotificationController.onNotification();
  useEffect(() => {
    const fetchEnumsAndPersistAwsUrl = async () => {
      try {
        const enumsData = await AuthController.getAwsEnums();
        console.log(enumsData, "datais");
        store.dispatch(setAwsUrlEnum(enumsData));
      } catch (err) {
        console.error("Failed to fetch enums:", err);
      }
    };

    fetchEnumsAndPersistAwsUrl();
  }, []);
  return (
    <div>
      <Routes>
        <Route path="" element={<PublicRoutes />}>
          {publicRoutes.map((route) => (
            <Route
              path={route.path}
              key={route.key}
              element={<route.component />}
            />
          ))}
        </Route>

        <Route path="" element={<ProtectedRoutes />}>
          {protectedRoutes.map((route) => (
            <Route
              path={route.path}
              key={route.key}
              element={<route.component />}
            />
          ))}
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;
